import React, { useEffect, useState } from 'react';
import { Marker } from 'react-leaflet';
import L, { DivIcon } from 'leaflet';
import { createRoot } from 'react-dom/client';
import { IAsset } from 'models/Assets';
import cctvSuccessIcon from 'pictures/cctv_success.png';
import { BLUE, GREEN, RED } from 'data/colors';

type Props = {
    children: React.ReactNode;
    asset: IAsset;
    eventHandlers?: Record<string, (e: any) => void>;
};

const MarkerCCTV: React.FC<Props> = ({ children, asset, eventHandlers }) => {
    const containerId = `preview-container-${asset.id}`;
    const { latitude, longitude } = asset;
    const pos: [number, number] | null = latitude && longitude ? [latitude, longitude] : null;
    const [position, setPositon] = useState<[number, number] | null>(pos);
    // Recalcular la posición del PMV según el cuerpo A o B
    useEffect(() => {
        // Obtener el último elemento de la descripción
        const cuerpo = asset.description.trim().split(' ').pop();
        if (latitude && longitude) {
            if (cuerpo === 'A') {
                setPositon([latitude, longitude]);
            } else if (cuerpo === 'B') {
                setPositon([latitude, longitude]);
            }
        }
    }, [asset]);

    const customHtml = `
        <div style="
                border: 3px solid ${asset.is_online ? GREEN : RED};
                width: 100px;
                height: 100px;
        ">
            <h3 style="
                width: 100%;
                height: 30%;
                display: flex;
                align-items: center;
                font-size: 12px;
                font-weight: bold;
                margin-bottom: 0px;
                background-color: white;
            ">${asset.description}</h3>
            <div style="
                background-color: none;
                width: 100%;
                height: 70%;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                text-align: center; 
                font-size: 8px;">
                <div id="${containerId}"></div>
            </div>
        </div>
    `;

    const customIcon: DivIcon = L.divIcon({
        html: customHtml,
        className: 'custom-div-icon',
        iconSize: [50, 100], // Ajusta el tamaño según sea necesario
    });

    useEffect(() => {
        const container = document.getElementById(containerId);
        if (container) {
            const root = createRoot(container);
            root.render(
                <img style={{ height: "60px" }} src={cctvSuccessIcon} alt="" />
            );
        } else {
            console.error(`Container with id ${containerId} not found`);
        }
    }, [containerId, position, asset, children]);

    if (!position) return null;

    return (
        <Marker
            draggable={true}
            position={position}
            icon={customIcon}
            eventHandlers={eventHandlers}
        >{children}</Marker>
    );
};

export default MarkerCCTV;
